import { Card, Typography } from "antd";
import styles from "../../../deliveryServices/DeliveryServices.module.css";

const { Text } = Typography;

function ProcessingCard({ date }) {
  return (
    <Card className={styles.dsCardStyle}>
      <Text className={styles.dsCardTitle}>DoorDash Request Submitted</Text>
      <p className={styles.dsCardDate}>{date}</p>
      <p className={styles.dsFormLabels}>
        A DoorDash representative will reach out to you once your account is
        ready for onboarding. If you need clarification or assistance, reach out
        to Customer Service at <b>(818) 235-1327</b>.
      </p>
    </Card>
  );
}

export default ProcessingCard;
